import { ReactElement } from "react"

import NavBarHorizontal from "./navBarHorizontal"
import NavBarVertical from "./navBarVertical"
import { useGetState } from "../../../hooks/useGetState"
import { getSideBar } from "../../../redux/preferencesSlice"

export const NAV_ICON_SX = {
    color: "text.primary",
    mr: 3,
    stroke: "#ffffff",
    strokeWidth: 0.5,
}

type NavBarWrapperProps = {
    groups: string[]
    children: ReactElement
}

/**
 * Appends nav-bar navigation functionality into application content box
 * (which should be supplied to this component via `children`)
 *
 * @example
 * <NavBarWrapper groups={groups}>
 *     <ApplicationContentBox>
 * </NavBarWrapper>
 */
const NavBarWrapper = ({
    groups,
    children,
}: NavBarWrapperProps): ReactElement => {
    const sideBar = useGetState(getSideBar)
    return sideBar ? (
        <NavBarVertical groups={groups}>{children}</NavBarVertical>
    ) : (
        <NavBarHorizontal groups={groups}>{children}</NavBarHorizontal>
    )
}

export default NavBarWrapper
